<template>
  <div>
    <article class="py-8">
      <h2 class="mb-4 md:mb-8 text-lg lg:text-xl">
        Related Collection Objects
      </h2>
      <LoadingSpinner
        v-if="isLoading"
        data-testid="relations-loading-message"
        class="text-xsoke w-18"
      />
      <div v-if="error" role="alert">
        <h3 class="text-lg lg:text-xl">{{ error }}</h3>
      </div>
      <CollectionObjectsTagsSearch
        v-if="tags"
        :tags="tags.objectRecordTags"
        :object-record-id="objectRecordId"
        data-testid="related-objects-section"
      />
    </article>
  </div>
</template>

<script>
import api from "@js/eHive/apiClient";
import LoadingSpinner from "@Vue/Core/LoadingSpinner.vue";
import CollectionObjectsTagsSearch from "./CollectionObjectTagsSearch.vue";

export default {
  name: "CollectionObjectRelations",

  components: { CollectionObjectsTagsSearch, LoadingSpinner },

  props: {
    objectRecordId: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      isLoading: false,
      error: false,
      tags: null
    };
  },

  async created() {
    this.isLoading = true;

    try {
      this.tags = await api.getObjectTags(this.objectRecordId);
    } catch (error) {
      this.error = true;
    }

    this.isLoading = false;
  }
};
</script>
